import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import MD5 from "crypto-js/md5";
import ProposalActivity from './ProposalActivity';
import ProposalPeriod from './ProposalPeriod';
import ProposalExpense from './ProposalExpense';
import ProposalJoin from './ProposalJoin';
import ProposalArea from './ProposalArea';
import ProposalAreaBenefit from './ProposalAreaBenefit';
import ProposalEquipment from './ProposalEquipment';

export default function ProposalPlan(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;
    let isReadOnly = decode.readOnly;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [data, setData] = React.useState(null);
    let [readOnly, setReadOnly] = React.useState(false);

    let [ethics, setEthics] = React.useState(0);
    let [human, setHuman] = React.useState(0);
    let [humanCertified, setHumanCertified] = React.useState(null);
    let [biosafety, setBiosafety] = React.useState(0);
    let [biosafetyCertified, setBiosafetyCertified] = React.useState(0);
    let [animal, setAnimal] = React.useState(0);
    let [chemical, setChemical] = React.useState(0);

    let [misconductBase64, setMisconductBase64] = React.useState(null);
    let [humanBase64, setHumanBase64] = React.useState(null);
    let [biosafetyBase64, setBiosafetyBase64] = React.useState(null);
    let [chemicalLabBase64, setChemicalLabBase64] = React.useState(null);
    let [chemicalCertificateBase64, setChemicalCertificateBase64] = React.useState(null);
    let [animalCertificateBase64, setAnimalCertificateBase64] = React.useState(null);
    let [animalLicenseBase64, setAnimalLicenseBase64] = React.useState(null);
    let [animalNotiBase64, setAnimalNotiBase64] = React.useState(null);
    let [animalProductionBase64, setAnimalProductionBase64] = React.useState(null);
    let [animalProcessBase64, setAnimalProcessBase64] = React.useState(null);
    let refMisconductFile = React.useRef();
    let refHumanFile = React.useRef();
    let refBiosafetyFile = React.useRef();
    let refChemicalLabFile = React.useRef();
    let refChemicalCertificateFile = React.useRef();
    let refAnimalCertificateFile = React.useRef();
    let refAnimalLicenseFile = React.useRef();
    let refAnimalNotiFile = React.useRef();
    let refAnimalProductionFile = React.useRef();
    let refAnimalProcessFile = React.useRef();
    const handleClickMisconductFile = React.useCallback(() => refMisconductFile.current?.click(), []);
    const handleClickHumanFile = React.useCallback(() => refHumanFile.current?.click(), []);
    const handleClickBiosafetyFile = React.useCallback(() => refBiosafetyFile.current?.click(), []);
    const handleClickChemicalLabFile = React.useCallback(() => refChemicalLabFile.current?.click(), []);
    const handleClickChemicalCertificateFile = React.useCallback(() => refChemicalCertificateFile.current?.click(), []);
    const handleClickAnimalCertificateFile = React.useCallback(() => refAnimalCertificateFile.current?.click(), []);
    const handleClickAnimalLicenseFile = React.useCallback(() => refAnimalLicenseFile.current?.click(), []);
    const handleClickAnimalNotiFile = React.useCallback(() => refAnimalNotiFile.current?.click(), []);
    const handleClickAnimalProductionFile = React.useCallback(() => refAnimalProductionFile.current?.click(), []);
    const handleClickAnimalProcessFile = React.useCallback(() => refAnimalProcessFile.current?.click(), []);
    let [misconductFileSelected, setMisconductFileSelected] = React.useState(null);
    let [humanFileSelected, setHumanFileSelected] = React.useState(null);
    let [biosafetyFileSelected, setBiosafetyFileSelected] = React.useState(null);
    let [chemicalLabFileSelected, setChemicalLabFileSelected] = React.useState(null);
    let [chemicalCertificateFileSelected, setChemicalCertificateFileSelected] = React.useState(null);
    let [animalCertificateFileSelected, setAnimalCertificateFileSelected] = React.useState(null);
    let [animalLicenseFileSelected, setAnimalLicenseFileSelected] = React.useState(null);
    let [animalNotiFileSelected, setAnimalNotiFileSelected] = React.useState(null);
    let [animalProductionFileSelected, setAnimalProductionFileSelected] = React.useState(null);
    let [animalProcessFileSelected, setAnimalProcessFileSelected] = React.useState(null);

    let refChemicalLabName = React.useRef();
    let refTrlLevel = React.useRef();
    let refTrlDetail = React.useRef();
    let refTrlFinishLevel = React.useRef();
    let refTrlFinishDetail = React.useRef();
    let refSrlLevel = React.useRef();
    let refSrlDetail = React.useRef();
    let refSrlFinishLevel = React.useRef();
    let refSrlFinishDetail = React.useRef();
    let refPotential = React.useRef();
    let refPrevention = React.useRef();
    let refConnections = React.useRef();
    let refStakeholder = React.useRef();

    React.useEffect(() => {
        //window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if ([Utils.PROPOSAL_STATUS_APPROVE].includes(resDetail.status)) {
                        setReadOnly(true);
                    }

                    if(isReadOnly) {
                        setReadOnly(isReadOnly);
                    }

                    if (prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }
                }

                const resData = await getData();
                if(resData) {
                    setData(resData);
                    setEthics(resData.ethics);
                    setHuman(resData.human);
                    setHumanCertified(resData.humanCertified);
                    setBiosafety(resData.biosafety);
                    setBiosafetyCertified(resData.biosafetyCertified);
                    setAnimal(resData.animal);
                    setChemical(resData.chemical);
                    refChemicalLabName.current.value = resData.chemicalLabName;
                    refTrlLevel.current.value = resData.trlLevel;
                    refTrlDetail.current.value = resData.trlDetail;
                    refTrlFinishLevel.current.value = resData.trlFinishLevel;
                    refTrlFinishDetail.current.value = resData.trlFinishDetail;
                    refSrlLevel.current.value = resData.srlLevel;
                    refSrlDetail.current.value = resData.srlDetail;
                    refSrlFinishLevel.current.value = resData.srlFinishLevel;
                    refSrlFinishDetail.current.value = resData.srlFinishDetail;
                    refPotential.current.value = resData.potential;
                    refPrevention.current.value = resData.prevention;
                    refConnections.current.value = resData.connections;
                    refStakeholder.current.value = resData.stakeholder;

                    setMisconductFileSelected(resData.misconductFile);
                    setHumanFileSelected(resData.humanFile);
                    setBiosafetyFileSelected(resData.biosafetyFile);
                    setChemicalLabFileSelected(resData.chemicalLabFile);
                    setChemicalCertificateFileSelected(resData.chemicalCertificateFile);
                    setAnimalCertificateFileSelected(resData.animalCertificateFile);
                    setAnimalLicenseFileSelected(resData.animalLicenseFile);
                    setAnimalNotiFileSelected(resData.animalNotiFile);
                    setAnimalProductionFileSelected(resData.animalProductionFile);
                    setAnimalProcessFileSelected(resData.animalProcessFile);
                }

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getData() {
        const response = await fetch(Config.apiUrl +'/proposalPlan/viewInfo', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        //if(readOnly) {
        //    navigate((prop.lang === 'en' ? '/en':'') + '/proposalApprove');
        //}
        //else {
        navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
        //}
    };

    const onSubmit = async () => {
        let chemicalLabName = refChemicalLabName.current.value;
        let trlLevel = refTrlLevel.current.value;
        let trlDetail = refTrlDetail.current.value;
        let trlFinishLevel = refTrlFinishLevel.current.value;
        let trlFinishDetail = refTrlFinishDetail.current.value;
        let srlLevel = refSrlLevel.current.value;
        let srlDetail = refSrlDetail.current.value;
        let srlFinishLevel = refSrlFinishLevel.current.value;
        let srlFinishDetail = refSrlFinishDetail.current.value;
        let connections = refConnections.current.value;
        let stakeholder = refStakeholder.current.value;
        let potential = refPotential.current.value;
        let prevention = refPrevention.current.value;

        let misconductFileName = refMisconductFile.current.value;
        let humanFileName = refHumanFile.current.value;
        let biosafetyFileName = refBiosafetyFile.current.value;
        let chemicalLabFileName = refChemicalLabFile.current.value;
        let chemicalCertificateFileName = refChemicalCertificateFile.current.value;

        let animalCertificateFileName = refAnimalCertificateFile.current.value;
        let animalLicenseFileName = refAnimalLicenseFile.current.value;
        let animalNotiFileName = refAnimalNotiFile.current.value;
        let animalProductionFileName = refAnimalProductionFile.current.value;
        let animalProcessFileName = refAnimalProcessFile.current.value;

        if(ethics === 1 && !misconductFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach a certificate of completion of training courses related to research misconduct (Research Misconduct)':'กรุณาระบุ แนบใบประกาศนียบัตรผ่านการอบรมหลักสูตรที่เกี่ยวข้องกับการประพฤติผิดทางการวิจัย (Research Misconduct)');
            refMisconductFile.current.focus();
        }
        else if(human === 1 && humanCertified===1 && !humanFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach a human research ethics certificate document':'กรุณาระบุ แนบเอกสารใบรับรองจริยธรรมการวิจัยในมนุษย์ (Certificate of Approval: COA / Certificate of Exempt: COE)');
            refHumanFile.current.focus();
        }
        else if(biosafety === 1 && biosafetyCertified===1 && !biosafetyFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach a certificate of approval to conduct research related to biosafety':'กรุณาระบุ แนบเอกสารใบรับรองการอนุมัติให้ดำเนินการวิจัยที่เกี่ยวข้องกับความปลอดภัยทางชีวภาพ');
            refBiosafetyFile.current.focus();
        }
        else if(animal === 1 && !animalCertificateFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach a certificate of approval for animal use for scientific purposes (from the National Science and Technology Development Agency)':'กรุณาระบุ แนบเอกสารใบรับรองการอนุมัติให้ดำเนินการต่อสัตว์เพื่องานทางวิทยาศาสตร์ (จาก คกส.)');
            refAnimalCertificateFile.current.focus();
        }
        else if(animal === 1 && !animalLicenseFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach the permit document for using animals for scientific purposes.':'กรุณาระบุ แนบเอกสารใบอนุญาตใช้สัตว์เพื่องานทางวิทยาศาสตร์');
            refAnimalLicenseFile.current.focus();
        }
        else if(chemical === 1 && !chemicalLabFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach a researcher\'s certificate document that works in a laboratory related to chemicals':'กรุณาระบุ แนบเอกสารใบรับรองนักวิจัยที่ดำเนินงานในห้องปฏิบัติการที่เกี่ยวข้องกับสารเคมี');
            refChemicalLabFile.current.focus();
        }
        else if(chemical === 1 && !chemicalCertificateFileSelected) {
            toast.error(prop.lang === 'en' ? 'Please specify Attach a certificate of completion of laboratory safety training':'กรุณาระบุ แนบใบประกาศนียบัตรผ่านการอบรมความปลอดภัยในห้องปฏิบัติการ');
            refChemicalCertificateFile.current.focus();
        }
        else if(chemical === 1 && chemicalLabName === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Chemical Lab Name':'กรุณาระบุ ชื่อห้องปฏิบัติการ');
            refChemicalLabName.current.focus();
        }
        else if(potential === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Potential risks':'กรุณาระบุ ความเสี่ยงที่อาจเกิดขึ้น');
            refPotential.current.focus();
        }
        else if(prevention === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Guidelines for risk prevention and resolution':'แนวทางการป้องกันและแก้ไขปัญหาความเสี่ยง');
            refPrevention.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {

                            let misconductFile = null;
                            let humanFile = null;
                            let biosafetyFile = null;
                            let chemicalLabFile = null;
                            let chemicalCertificateFile = null;
                            if(misconductFileName) {
                                misconductFile = MD5('misconductFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + misconductFileName.split('.').pop();
                            }
                            if(humanFileName) {
                                humanFile = MD5('humanFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + humanFileName.split('.').pop();
                            }
                            if(biosafetyFileName) {
                                biosafetyFile = MD5('biosafetyFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + biosafetyFileName.split('.').pop();
                            }
                            if(chemicalLabFileName) {
                                chemicalLabFile = MD5('chemicalLabFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + chemicalLabFileName.split('.').pop();
                            }
                            if(chemicalCertificateFileName) {
                                chemicalCertificateFile = MD5('chemicalCertificateFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + chemicalCertificateFileName.split('.').pop();
                            }

                            let animalCertificateFile = null;
                            let animalLicenseFile = null;
                            let animalNotiFile = null;
                            let animalProductionFile = null;
                            let animalProcessFile = null;
                            if(animalCertificateFileName) {
                                animalCertificateFile = MD5('animalCertificateFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + animalCertificateFileName.split('.').pop();
                            }
                            if(animalLicenseFileName) {
                                animalLicenseFile = MD5('animalLicenseFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + animalLicenseFileName.split('.').pop();
                            }
                            if(animalNotiFileName) {
                                animalNotiFile = MD5('animalNotiFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + animalNotiFileName.split('.').pop();
                            }
                            if(animalProductionFileName) {
                                animalProductionFile = MD5('animalProductionFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + animalProductionFileName.split('.').pop();
                            }
                            if(animalProcessFileName) {
                                animalProcessFile = MD5('animalProcessFile_' + moment().format("YMMDDHHmmss")).toString() + '.' + animalProcessFileName.split('.').pop();
                            }

                            let param = {
                                proposalId: proposalId,
                                ethics: ethics,
                                misconductFile: misconductFile,
                                misconductBase64: misconductBase64,
                                misconductCurrentFile: data?.misconductFile,
                                misconductFileSelected: misconductFileSelected,
                                human: human,
                                humanCertified: humanCertified,
                                humanFile: humanFile,
                                humanBase64: humanBase64,
                                humanCurrentFile: data?.humanFile,
                                humanFileSelected: humanFileSelected,
                                biosafety: biosafety,
                                biosafetyCertified: biosafetyCertified,
                                biosafetyFile: biosafetyFile,
                                biosafetyBase64: biosafetyBase64,
                                biosafetyCurrentFile: data?.biosafetyFile,
                                biosafetyFileSelected: biosafetyFileSelected,

                                animal: animal,
                                animalCertificateFile: animalCertificateFile,
                                animalCertificateBase64: animalCertificateBase64,
                                animalCertificateCurrentFile: data?.animalCertificateFile,
                                animalCertificateFileSelected: animalCertificateFileSelected,

                                animalLicenseFile: animalLicenseFile,
                                animalLicenseBase64: animalLicenseBase64,
                                animalLicenseCurrentFile: data?.animalLicenseFile,
                                animalLicenseFileSelected: animalLicenseFileSelected,

                                animalNotiFile: animalNotiFile,
                                animalNotiBase64: animalNotiBase64,
                                animalNotiCurrentFile: data?.animalNotiFile,
                                animalNotiFileSelected: animalNotiFileSelected,

                                animalProductionFile: animalProductionFile,
                                animalProductionBase64: animalProductionBase64,
                                animalProductionCurrentFile: data?.animalProductionFile,
                                animalProductionFileSelected: animalProductionFileSelected,

                                animalProcessFile: animalProcessFile,
                                animalProcessBase64: animalProcessBase64,
                                animalProcessCurrentFile: data?.animalProcessFile,
                                animalProcessFileSelected: animalProcessFileSelected,

                                chemical: chemical,
                                chemicalLabFile: chemicalLabFile,
                                chemicalLabBase64: chemicalLabBase64,
                                chemicalLabCurrentFile: data?.chemicalLabFile,
                                chemicalLabFileSelected: chemicalLabFileSelected,
                                chemicalCertificateFile: chemicalCertificateFile,
                                chemicalCertificateBase64: chemicalCertificateBase64,
                                chemicalCertificateCurrentFile: data?.chemicalCertificateFile,
                                chemicalCertificateFileSelected: chemicalCertificateFileSelected,
                                chemicalLabName: chemicalLabName.trim(),
                                trlLevel: trlLevel.trim(),
                                trlDetail: trlDetail.trim(),
                                trlFinishLevel: trlFinishLevel.trim(),
                                trlFinishDetail: trlFinishDetail.trim(),
                                srlLevel: srlLevel.trim(),
                                srlDetail: srlDetail.trim(),
                                srlFinishLevel: srlFinishLevel.trim(),
                                srlFinishDetail: srlFinishDetail.trim(),
                                connections: connections.trim(),
                                stakeholder: stakeholder.trim(),
                                potential: potential.trim(),
                                prevention: prevention.trim(),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateInfo(param);

                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Part 2 Plan has been recorded successfully.':'อัพเดตข้อมูล แผนงาน เรียบร้อย');
                                setTimeout(function () {
                                    window.location.reload();
                                }, 1500);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updateInfo(param) {
        const response = await fetch(Config.apiUrl +'/proposalPlan/update', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const removeMisconductFile = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ไฟล์ที่เกี่ยวข้องจะถูกลบ',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        refMisconductFile.current.value = '';
                        setMisconductFileSelected(null);
                        setMisconductBase64(null);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {
                        setEthics(1);
                    }
                }
            ]
        });
    };
    const removeHumanFile = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ไฟล์ที่เกี่ยวข้องจะถูกลบ',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        refHumanFile.current.value = '';
                        setHumanFileSelected(null);
                        setHumanBase64(null);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {
                        setHuman(1);
                    }
                }
            ]
        });
    };
    const removeBiosafetyFile = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ไฟล์ที่เกี่ยวข้องจะถูกลบ',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        refBiosafetyFile.current.value = '';
                        setBiosafetyFileSelected(null);
                        setBiosafetyBase64(null);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {
                        setBiosafety(1);
                    }
                }
            ]
        });
    };
    const removeAnimalLabFile = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ไฟล์ที่เกี่ยวข้องจะถูกลบ',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        setAnimalCertificateFileSelected(null);
                        setAnimalLicenseFileSelected(null);
                        setAnimalNotiFileSelected(null);
                        setAnimalProcessFileSelected(null);
                        setAnimalProductionFileSelected(null);

                        setAnimalCertificateBase64(null);
                        setAnimalLicenseBase64(null);
                        setAnimalNotiBase64(null);
                        setAnimalProcessBase64(null);
                        setAnimalProductionBase64(null);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {
                        setAnimal(1);
                    }
                }
            ]
        });
    };
    const removeChemicalLabFile = () => {
        setChemical(chemical);
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ไฟล์ที่เกี่ยวข้องจะถูกลบ',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        setChemical(0);
                        refChemicalLabFile.current.value = '';
                        setChemicalLabFileSelected(null);
                        setChemicalLabBase64(null);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {
                        setChemical(1);
                    }
                }
            ]
        });
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h3 className="title-bar mt-4 mb-2">{prop.lang === 'en' ? 'Part 3 Plan':'ส่วนที่ 3 แผนงาน'}</h3>
                                <h4 className="title-line-left mb-2">1. {prop.lang === 'en' ? 'Research Operation Plan (showing the operation plan for each activity and the time period used in each fiscal year)':'แผนการดำเนินงานวิจัย (แสดงแผนการดำเนินงานรายกิจกรรมและระยะเวลาที่ใช้ ในแต่ละปีงบประมาณ)'}</h4>
                                <ProposalActivity proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">2. {prop.lang === 'en' ? 'Performance in each period':'ผลงานในแต่ละช่วงเวลา'}</h4>
                                <ProposalPeriod proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">3. {prop.lang === 'en' ? 'Research area: Please specify the research location classified by research project using the system database and add specific names such as community, village.':'พื้นที่ทำวิจัย : โปรดระบุสถานที่ทำวิจัยจำแนกตามโครงการวิจัยโดยใช้ฐานข้อมูลจากระบบ และเพิ่มเติมชื่อเฉพาะ เช่น ชุมชน  หมู่บ้าน'}</h4>
                                <ProposalArea proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">4. {prop.lang === 'en' ? 'Areas benefiting from research':'พื้นที่ที่ได้รับประโยชน์จากการวิจัย'}</h4>
                                <ProposalAreaBenefit proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">5. {prop.lang === 'en' ? 'Budget expenditure plan for research projects':'แผนการใช้จ่ายงบประมาณของโครงการวิจัย'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>5.1 {prop.lang === 'en' ? 'Show the estimated budget details throughout the project (in the case of a budget request for a continuous project with a research duration of more than 1 year, show the budget throughout the operational plan) divided into the following categories':'แสดงรายละเอียดประมาณการงบประมาณตลอดโครงการ (กรณีของบประมาณเป็นโครงการต่อเนื่อง ระยะเวลาดำเนินการวิจัยมากกว่า 1 ปี ให้แสดงงบประมาณตลอดแผนการดำเนินงาน) โดยแบ่งเป็นหมวดต่าง ๆ ดังนี้'}</h6>
                                            <ProposalExpense proposalId={proposalId} member={member} readOnly={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12 mt-4">
                                        <div className="form-group">
                                            <h6>5.2 {prop.lang === 'en' ? 'Details of equipment purchase: If you need to purchase equipment, please provide the following details':'รายละเอียดการจัดซื้อครุภัณฑ์ : กรณีมีความต้องการซื้อครุภัณฑ์ให้ใส่รายละเอียด ดังนี้'}</h6>
                                            <ProposalEquipment proposalId={proposalId} member={member} readOnly={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">6. {prop.lang === 'en' ? 'Research Standards':'มาตรฐานการวิจัย'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="ethics" name="ethics" onChange={() => {
                                                setEthics(ethics ? null:1);
                                                if(ethics===1 && misconductFileSelected) {
                                                    removeMisconductFile();
                                                }
                                            }} checked={ethics===1} />
                                            <label className="form-check-label h6 fw-500" htmlFor="ethics">
                                                {prop.lang === 'en' ? 'Research Ethics':'จริยธรรมการวิจัย'}
                                            </label>
                                        </div>
                                        <div className={"row mt-2 ps-5" + (ethics ? '':' d-none')}>
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                <table className="table table-info table-hover text-center">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                            {
                                                                readOnly ? '' : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                            }
                                                            {
                                                                data?.misconductFile && misconductFileSelected ? <th className="text-center" style={{width:'100px'}}>{data?.misconductFile ? (prop.lang === 'en' ? 'Download':'ดาวน์โหลด'):''}</th> : ''
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="text-start">
                                                                {prop.lang === 'en' ? 'Attach a certificate of completion of training courses related to research misconduct':'แนบใบประกาศนียบัตรผ่านการอบรมหลักสูตรที่เกี่ยวข้องกับการประพฤติผิดทางการวิจัย'} (Research Misconduct)
                                                                <p className="mb-0 text-muted">
                                                                    {data?.misconductFile ? '':misconductFileSelected}
                                                                </p>
                                                            </td>
                                                            {
                                                                readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickMisconductFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                            }
                                                            {
                                                                data?.misconductFile && misconductFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.misconductFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                            }

                                                        </tr>
                                                    </tbody>
                                                </table>
                                                </div>

                                                <input type="file" className="form-control d-none" ref={refMisconductFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setMisconductFileSelected(e.target.files[0].name);
                                                            setMisconductBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />

                                                <input type="file" className="form-control d-none" ref={refChemicalLabFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            console.log(e);
                                                            console.log(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="human" name="human" onChange={() => {
                                                setHuman(human ? null:1);
                                                if(human===1 && humanFileSelected) {
                                                    removeHumanFile();
                                                }
                                            }} checked={human===1} />
                                            <label className="form-check-label h6 fw-500" htmlFor="human">
                                                {prop.lang === 'en' ? 'Human Research Standards':'มาตรฐานการวิจัยในมนุษย์'}
                                            </label>
                                        </div>
                                        <div className="row mt-2 ps-5">
                                            <div className="col-12">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="humanCertified2" name="humanCertified" onChange={() => setHumanCertified(null)} checked={humanCertified!==1} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="humanCertified2">{prop.lang === 'en' ? 'The research project has not been approved by the Human Research Ethics Committee':<>โครงการวิจัยยัง<u>ไม่ได้รับ</u>การรับรองจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์</>}</label>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="humanCertified1" name="humanCertified" onChange={() => setHumanCertified(1)} checked={humanCertified===1} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="humanCertified1">{prop.lang === 'en' ? 'The research project has been approved by the Human Research Ethics Committee':<>โครงการวิจัย<u>ได้รับ</u>การรับรองจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์</>}</label>
                                                </div>
                                            </div>
                                            <div className={"col-12 mt-2" + (human===1 && humanCertified===1 ? '':' d-none')}>
                                                <div className="table-responsive">
                                                <table className="table table-info table-hover text-center">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                        {
                                                            readOnly ? '' : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                        }
                                                        {
                                                            data?.humanFile && humanFileSelected ? <th className="text-center" style={{width:'100px'}}>{data?.humanFile ? (prop.lang === 'en' ? 'Download':'ดาวน์โหลด'):''}</th> : ''
                                                        }
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-start">
                                                            {prop.lang === 'en' ? 'Attach a human research ethics certificate document':'แนบเอกสารใบรับรองจริยธรรมการวิจัยในมนุษย์'} (Certificate of Approval: COA / Certificate of Exempt: COE)
                                                            <p className="mb-0 text-muted">
                                                                {data?.humanFile ? '':humanFileSelected}
                                                            </p>
                                                        </td>
                                                        {
                                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickHumanFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                        }
                                                        {
                                                            data?.humanFile && humanFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.humanFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                        }

                                                    </tr>
                                                    </tbody>
                                                </table>
                                                </div>

                                                <input type="file" className="form-control d-none" ref={refHumanFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setHumanFileSelected(e.target.files[0].name);
                                                            setHumanBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="biosafety" name="biosafety" onChange={() => {
                                                setBiosafety(biosafety ? null:1);
                                                if(biosafety===1 && biosafetyFileSelected) {
                                                    removeBiosafetyFile();
                                                }
                                            }} checked={biosafety===1} />
                                            <label className="form-check-label h6 fw-500" htmlFor="biosafety">
                                                {prop.lang === 'en' ? 'Biosafety standards':'มาตรฐานความปลอดภัยทางชีวภาพ'}
                                            </label>
                                        </div>
                                        <div className="row mt-2 ps-5">
                                            <div className="col-12">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="biosafetyCertified2" name="biosafetyCertified" onChange={() => setBiosafetyCertified(null)} checked={biosafetyCertified!==1} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="biosafetyCertified2">{prop.lang === 'en' ? 'The research project has not been approved by the Biosafety Control Committee':<>โครงการวิจัยยัง<u>ไม่ได้รับ</u>รับการรับรองจากคณะกรรมการควบคุมความปลอดภัยทางชีวภาพ</>}</label>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="biosafetyCertified1" name="biosafetyCertified" onChange={() => setBiosafetyCertified(1)} checked={biosafetyCertified===1} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="biosafetyCertified1">{prop.lang === 'en' ? 'The research project has been approved by the Biosafety Control Committee':<>โครงการวิจัย<u>ได้รับ</u>การรับรองจากคณะกรรมการควบคุมความปลอดภัยทางชีวภาพ</>}</label>
                                                </div>
                                            </div>
                                            <div className={"col-12 mt-2" + (biosafety===1 && biosafetyCertified===1 ? '':' d-none')}>
                                                <div className="table-responsive">
                                                <table className="table table-info table-hover text-center">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                        {
                                                            readOnly ? '' : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                        }
                                                        {
                                                            data?.biosafetyFile && biosafetyFileSelected ? <th className="text-center" style={{width:'100px'}}>{data?.biosafetyFile ? (prop.lang === 'en' ? 'Download':'ดาวน์โหลด'):''}</th> : ''
                                                        }
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-start">
                                                            {prop.lang === 'en' ? 'Attach a certificate of approval to conduct research related to biosafety':'แนบเอกสารใบรับรองการอนุมัติให้ดำเนินการวิจัยที่เกี่ยวข้องกับความปลอดภัยทางชีวภาพ'}
                                                            <p className="mb-0 text-muted">
                                                                {data?.biosafetyFile ? '':biosafetyFileSelected}
                                                            </p>
                                                        </td>
                                                        {
                                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickBiosafetyFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                        }
                                                        {
                                                            data?.biosafetyFile && biosafetyFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.biosafetyFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                        }

                                                    </tr>
                                                    </tbody>
                                                </table>
                                                </div>

                                                <input type="file" className="form-control d-none" ref={refBiosafetyFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setBiosafetyFileSelected(e.target.files[0].name);
                                                            setBiosafetyBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="animal" name="animal" onChange={() => {
                                                setAnimal(animal ? null:1);
                                                if(animal===1 && animalCertificateFileSelected || animalLicenseFileSelected) {
                                                    removeAnimalLabFile();
                                                }
                                            }} checked={animal===1} />
                                            <label className="form-check-label h6 fw-500" htmlFor="animal">
                                                {prop.lang === 'en' ? 'Standards for the Practice of Animals for Scientific Purposes':'มาตรฐานการดำเนินการต่อสัตว์เพื่องานทางวิทยาศาสตร์'}
                                            </label>
                                        </div>
                                        <div className="row mt-2 ps-5">
                                            <div className={"col-12 mt-2" + (animal===1 ? '':' d-none')}>
                                                <div className="table-responsive">
                                                    <table className="table table-info table-hover text-center">
                                                        <thead>
                                                        <tr>
                                                            <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                            {
                                                                readOnly ? '' : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                            }
                                                            {
                                                                data?.animalCertificateFile && animalCertificateFileSelected ? <th className="text-center" style={{width:'100px'}}>{data?.animalCertificateFile ? (prop.lang === 'en' ? 'Download':'ดาวน์โหลด'):''}</th> : ''
                                                            }
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td className="text-start">
                                                                {prop.lang === 'en' ? 'Attach a certificate of approval for animal use for scientific purposes (from the National Science and Technology Development Agency)':'แนบเอกสารใบรับรองการอนุมัติให้ดำเนินการต่อสัตว์เพื่องานทางวิทยาศาสตร์ (จาก คกส.)'}
                                                                <p className="mb-0 text-muted">
                                                                    {data?.animalCertificateFile ? '':animalCertificateFileSelected}
                                                                </p>
                                                            </td>
                                                            {
                                                                readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickAnimalCertificateFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                            }
                                                            {
                                                                data?.animalCertificateFile && animalCertificateFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.animalCertificateFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                            }
                                                        </tr>
                                                        <tr>
                                                            <td className="text-start">
                                                                {prop.lang === 'en' ? 'Attach the permit document for using animals for scientific purposes':'แนบเอกสารใบอนุญาตใช้สัตว์เพื่องานทางวิทยาศาสตร์'}
                                                                <p className="mb-0 text-muted">
                                                                    {data?.animalLicenseFile ? '':animalLicenseFileSelected}
                                                                </p>
                                                            </td>
                                                            {
                                                                readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickAnimalLicenseFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                            }
                                                            {
                                                                data?.animalLicenseFile && animalLicenseFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.animalLicenseFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                            }
                                                        </tr>
                                                        <tr>
                                                            <td className="text-start">
                                                                {prop.lang === 'en' ? 'Attach a document of notification of the place of operation of animals for scientific purposes (if any)':'แนบเอกสารใบจดแจ้งสถานที่ดำเนินการต่อสัตว์เพื่องานทางวิทยาศาสตร์ (ถ้ามี)'}
                                                                <p className="mb-0 text-muted">
                                                                    {data?.animalNotiFile ? '':animalNotiFileSelected}
                                                                </p>
                                                            </td>
                                                            {
                                                                readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickAnimalNotiFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                            }
                                                            {
                                                                data?.animalNotiFile && animalNotiFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.animalNotiFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                            }
                                                        </tr>
                                                        <tr>
                                                            <td className="text-start">
                                                                {prop.lang === 'en' ? 'Attach the license for producing animals for scientific purposes (if any)':'แนบเอกสารใบอนุญาตผลิตสัตว์เพื่องานทางวิทยาศาสตร์ (ถ้ามี)'}
                                                                <p className="mb-0 text-muted">
                                                                    {data?.animalProcessFile ? '':animalProcessFileSelected}
                                                                </p>
                                                            </td>
                                                            {
                                                                readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickAnimalProcessFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                            }
                                                            {
                                                                data?.animalProcessFile && animalProcessFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.animalProcessFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                            }
                                                        </tr>
                                                        <tr>
                                                            <td className="text-start">
                                                                {prop.lang === 'en' ? 'Attach a document of notification of animal conduct for scientific purposes in accordance with Section 31 (if any).':'แนบเอกสารใบรับแจ้งการดำเนินการต่อสัตว์เพื่องานทางวิทยาศาสตร์ ตามมาตรา 31 (ถ้ามี)'}
                                                                <p className="mb-0 text-muted">
                                                                    {data?.animalProductionFile ? '':animalProductionFileSelected}
                                                                </p>
                                                            </td>
                                                            {
                                                                readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickAnimalProductionFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                            }
                                                            {
                                                                data?.animalProductionFile && animalProductionFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.animalProductionFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                            }
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <input type="file" className="form-control d-none" ref={refAnimalCertificateFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setAnimalCertificateFileSelected(e.target.files[0].name);
                                                            setAnimalCertificateBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />

                                                <input type="file" className="form-control d-none" ref={refAnimalLicenseFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setAnimalLicenseFileSelected(e.target.files[0].name);
                                                            setAnimalLicenseBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />

                                                <input type="file" className="form-control d-none" ref={refAnimalNotiFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setAnimalNotiFileSelected(e.target.files[0].name);
                                                            setAnimalNotiBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />

                                                <input type="file" className="form-control d-none" ref={refAnimalProcessFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setAnimalProcessFileSelected(e.target.files[0].name);
                                                            setAnimalProcessBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />

                                                <input type="file" className="form-control d-none" ref={refAnimalProductionFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setAnimalProductionFileSelected(e.target.files[0].name);
                                                            setAnimalProductionBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="chemical" name="chemical"  onChange={() => {
                                                setChemical(chemical ? null:1);
                                                if(chemical===1 && chemicalLabFileSelected) {
                                                    removeChemicalLabFile();
                                                }
                                            }} checked={chemical===1} />
                                            <label className="form-check-label h6 fw-500" htmlFor="chemical">
                                                {prop.lang === 'en' ? 'Chemical Laboratory Safety Standards':'มาตรฐานความปลอดภัยห้องปฏิบัติการด้านสารเคมี'}
                                            </label>
                                        </div>
                                        <div className="row mt-2 ps-5">
                                            <div className={"col-12 mt-2" + (chemical===1 ? '':' d-none')}>
                                                <div className="table-responsive">
                                                <table className="table table-info table-hover text-center">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                        {
                                                            readOnly ? '' : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                        }
                                                        {
                                                            data?.chemicalLabFile && chemicalLabFileSelected ? <th className="text-center" style={{width:'100px'}}>{data?.chemicalLabFile ? (prop.lang === 'en' ? 'Download':'ดาวน์โหลด'):''}</th> : ''
                                                        }
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-start">
                                                            {prop.lang === 'en' ? 'Attach a researcher\'s certificate document that works in a laboratory related to chemicals':'แนบเอกสารใบรับรองนักวิจัยที่ดำเนินงานในห้องปฏิบัติการที่เกี่ยวข้องกับสารเคมี'}
                                                            <p className="mb-0 text-muted">
                                                                {data?.chemicalLabFile ? '':chemicalLabFileSelected}
                                                            </p>
                                                        </td>
                                                        {
                                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickChemicalLabFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                        }
                                                        {
                                                            data?.chemicalLabFile && chemicalLabFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.chemicalLabFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                        }

                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">
                                                            {prop.lang === 'en' ? 'Attach a certificate of completion of laboratory safety training':'แนบใบประกาศนียบัตรผ่านการอบรมความปลอดภัยในห้องปฏิบัติการ'}
                                                            <p className="mb-0 text-muted">
                                                                {data?.chemicalCertificateFile ? '':chemicalCertificateFileSelected}
                                                            </p>
                                                        </td>
                                                        {
                                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickChemicalCertificateFile}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                                        }
                                                        {
                                                            data?.chemicalCertificateFile && chemicalCertificateFileSelected ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_plan/' + data?.chemicalCertificateFile}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                                        }

                                                    </tr>
                                                    </tbody>
                                                </table>
                                                </div>

                                                <input type="file" className="form-control d-none" ref={refChemicalLabFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setChemicalLabFileSelected(e.target.files[0].name);
                                                            setChemicalLabBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />

                                                <input type="file" className="form-control d-none" ref={refChemicalCertificateFile} onChange={(e) => {
                                                    Utils.onSelectFile(e).then(
                                                        data => {
                                                            setChemicalCertificateFileSelected(e.target.files[0].name);
                                                            setChemicalCertificateBase64(data);
                                                        }
                                                    );
                                                }} accept={Utils.allowFileExtension} />
                                            </div>
                                            <div className="col-12 mt-2">
                                                <div className="form-group">
                                                    <span>{prop.lang === 'en' ? 'Chemical Lab Name':'ชื่อห้องปฏิบัติการ'}</span>
                                                    <input className="form-control" ref={refChemicalLabName} maxLength={250} disabled={readOnly} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">7. {prop.lang === 'en' ? 'Co-operating agencies/private sector or communities that jointly invest or operate':'หน่วยงานร่วมดำเนินการ/ภาคเอกชนหรือชุมชนที่ร่วมลงทุนหรือดำเนินการ'}</h4>
                                <ProposalJoin proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">8. {prop.lang === 'en' ? 'Current level of readiness (if any)':'ระดับความพร้อมที่มีอยู่ในปัจจุบัน (ถ้ามี)'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>8.1 {prop.lang === 'en' ? 'Level of technological readiness (Technology Readiness Level: TRL)':'ระดับความพร้อมทางเทคโนโลยี (Technology Readiness Level: TRL)'}</h6>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <span>{prop.lang === 'en' ? '1) TRL Level':'1) TRL ณ ปัจจุบัน ระดับ'}</span>
                                                    <input className="form-control" ref={refTrlLevel} maxLength={250} disabled={readOnly} />
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{prop.lang === 'en' ? 'Detail':'รายละเอียด'}</span>
                                                    <input className="form-control" ref={refTrlDetail} maxLength={250} disabled={readOnly} />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-md-4">
                                                    <span>{prop.lang === 'en' ? '2)  TRL Level Finish':'2) TRL เมื่องานวิจัยเสร็จสิ้นระดับ'}</span>
                                                    <input className="form-control" ref={refTrlFinishLevel} maxLength={250} disabled={readOnly} />
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{prop.lang === 'en' ? 'Detail':'รายละเอียด'}</span>
                                                    <input className="form-control" ref={refTrlFinishDetail} maxLength={250} disabled={readOnly} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>8.2 {prop.lang === 'en' ? 'Social readiness level (Societal Readiness Level: SRL)':'ระดับความพร้อมทางสังคม (Societal Readiness Level: SRL)'}</h6>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <span>{prop.lang === 'en' ? '1) SRL Level':'1) SRL ณ ปัจจุบัน ระดับ'}</span>
                                                    <input className="form-control" ref={refSrlLevel} maxLength={250} disabled={readOnly} />
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{prop.lang === 'en' ? 'Detail':'รายละเอียด'}</span>
                                                    <input className="form-control" ref={refSrlDetail} maxLength={250} disabled={readOnly} />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-md-4">
                                                    <span>{prop.lang === 'en' ? '2) SRL Level Finish':'2) SRL เมื่องานวิจัยเสร็จสิ้นระดับ'}</span>
                                                    <input className="form-control" ref={refSrlFinishLevel} maxLength={250} disabled={readOnly} />
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{prop.lang === 'en' ? 'Detail':'รายละเอียด'}</span>
                                                    <input className="form-control" ref={refSrlFinishDetail} maxLength={250} disabled={readOnly} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">9. {prop.lang === 'en' ? 'Links with researchers, stakeholders and users of research':'ความเชื่อมโยงกับนักวิจัย หรือผู้มีส่วนได้ส่วนเสีย และผู้ใช้ประโยชน์จากงานวิจัย'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>9.1 {prop.lang === 'en' ? 'Connections with other experts within and outside Thailand (if applicable) and plans to contact or build relationships with experts, including building a research team in the future.':'การเชื่อมโยงกับนักวิจัยที่เป็นผู้เชี่ยวชาญในสาขาวิชาที่ทำการวิจัยทั้งในและต่างประเทศ (ถ้ามี) (Connections with other experts within and outside Thailand) และแผนที่จะติดต่อหรือสร้างความสัมพันธ์กับผู้เชี่ยวชาญ รวมทั้งการสร้างทีมงานวิจัยในอนาคตด้วย'}</h6>
                                            <textarea className="form-control" ref={refConnections} maxLength={1000} rows={5} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>9.2 {prop.lang === 'en' ? 'Linking or collaborating with stakeholders and users of research (Stakeholder and User Engagement) by naming government agencies, private sectors, civil society and communities, clearly explaining the process of working together and linking research results to utilization, including explaining the ongoing process of users of research when the research project is completed.':'การเชื่อมโยงหรือความร่วมมือกับผู้มีส่วนได้ส่วนเสีย และผู้ใช้ประโยชน์จากงานวิจัย (Stakeholder and User Engagement) โดยระบุชื่อหน่วยงานภาครัฐ เอกชน ประชาสังคมและชุมชน โดยอธิบายกระบวนการดำเนินงานร่วมกันและการเชื่อมโยงการขับเคลื่อนผลการวิจัยไปสู่การใช้ประโยชน์อย่างชัดเจน รวมถึงอธิบายกระบวนการดำเนินงานต่อเนื่องของผู้ใช้ประโยชน์จากงานวิจัยเมื่อโครงการวิจัยเสร็จสิ้น '}</h6>
                                            <textarea className="form-control" ref={refStakeholder} maxLength={1000} rows={5} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">10. {prop.lang === 'en' ? 'Project Risks Identify risks or risk factors that may cause the project to fail or cause problems, such as copyright risks, risks to society, quality of life, morality, ethics, along with methods to prevent and solve those problems.':'ความเสี่ยงของโครงการ ระบุความเสี่ยงหรือปัจจัยเสี่ยงที่อาจทำให้โครงการไม่ประสบความสำเร็จหรือเกิดปัญหา  ความเสี่ยงเรื่องลิขสิทธิ์ ความเสี่ยงต่อสังคมคุณภาพชีวิต คุณธรรม จริยธรรม  พร้อมทั้งแนวทางการป้องกันและแก้ปัญหานั้น'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Please specify Potential risks':'ความเสี่ยงที่อาจเกิดขึ้น'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refPotential} maxLength={1000} rows={5} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Please specify Guidelines for risk prevention and resolution':'แนวทางการป้องกันและแก้ไขปัญหาความเสี่ยง'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refPrevention} maxLength={1000} rows={5} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    {
                                        !readOnly ? <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 